export function check_all_users(state = false, action) {
  if (action.type === 'CHECK_ALL') {
    return true;
  }
  if (action.type === 'CHECK_ALL_NOT') {
    return false;
  }
  return state;
}
